import { FC } from "react"
import { useTranslation } from "react-i18next"
import { YandexIcon } from "@/assets"
import { getRefCode } from "@/helpers/refCode"
import type { IAuthMode } from "../types"
import styles from "./YandexAuthButton.module.scss"

interface IYandexAuthButton {
  mode: IAuthMode
}

export const YandexAuthButton: FC<IYandexAuthButton> = ({ mode }) => {
  const { t } = useTranslation()

  const handleClick = () => {
    const refCode = getRefCode()
    const refParam = refCode ? `?refCode=${refCode}` : ""
    const intent = mode === "login" ? "login" : "create"
    window.location.href = `${import.meta.env.VITE_BACKEND}/api/auth/yandex/${intent}${refParam}`
  }

  const i18nPrefix = mode === "login" ? "login" : "register"

  return (
    <button
      className={styles.YandexAuthButton}
      onClick={handleClick}
      type="button"
    >
      <YandexIcon className={styles.YandexAuthButton_icon} />
      {t(`${i18nPrefix}.yandex`)}
    </button>
  )
}
